/**
 * Simple helper function to get today
 */
export function getToday(): Date {
  return new Date()
}

/**
 * Simple helper function to get yesterday
 */
export function getYesterday(): Date {
  return getDateNDaysBack(1)
}

/**
 *
 */
export function getDateNDaysBack(n: number): Date {
  const date = new Date()
  date.setDate(date.getDate() - n)
  return date
}

/**
 * Test if dateA is after or on dateB.
 */
export function isDateOnOrAfter(dateA: string, dateB: string): boolean {
  return dateA >= dateB
}

/**
 * Picks the most recent date from a list of dates.
 */
export function pickMostRecentDate(
  dateStrings: (string | null)[],
): string | null {
  return dateStrings.reduce<string | null>((mostRecent, date) => {
    if (date === null) {
      return mostRecent
    }

    if (mostRecent === null || mostRecent < date) {
      return date
    }

    return mostRecent
  }, null)
}

/**
 * Check if the dateString lies within the given noOfDays period
 */
export function checkIfDateIsWithinRange(
  dateString: string | null,
  noOfDays: number,
  currentDate: Date = new Date(),
) {
  if (!dateString) return false
  const date = new Date(dateString)

  // Calculate the difference in milliseconds between the current date and the given date
  const difference = currentDate.getTime() - date.getTime()

  // Convert the difference to days
  const differenceDays = Math.floor(difference / (1000 * 60 * 60 * 24))

  // Check if date is not in future and the difference is less than to 7
  return date < currentDate && differenceDays < noOfDays
}
